export const isNewVersionAvailable = (): Promise<{
    isNewVersion: boolean;
    version: string;
}> => {
    return new Promise((resolve, reject) => {
        $.get('/')
            .done((data) => {
                const parser = new DOMParser();
                const dom = parser.parseFromString(data, 'text/html');
                const latestVersion = $(dom.head).find('meta[name="version"]').first().attr('content') || '';
                const currentVersion = $(document).find('meta[name="version"]').first().attr('content');

                if (latestVersion !== currentVersion) {
                    resolve({
                        isNewVersion: true,
                        version: latestVersion
                    });
                } else {
                    resolve({
                        isNewVersion: false,
                        version: currentVersion
                    });
                }
            })
            .fail((err) => {
                reject(err);
            });
    });
};
